import { useEffect, useState } from "react";

export const MAX_SIDE = 450;
export const ENLARGED_WIDTH_RATIO = 2.65;
export const DEFAULT_BOX = { width: 300, height: 450, naturalWidth: 3000, naturalHeight: 4200 };

export const boxFor = (naturalWidth, naturalHeight) => {
  if (!(naturalWidth > 0) || !(naturalHeight > 0)) return DEFAULT_BOX;
  const scale = MAX_SIDE / Math.max(naturalWidth, naturalHeight);
  return {
    width: Math.round(naturalWidth * scale),
    height: Math.round(naturalHeight * scale),
    naturalWidth,
    naturalHeight,
  };
};

export const enlargedWidthOf = (box) => Math.round(box.width * ENLARGED_WIDTH_RATIO);

export const useImageBox = (src) => {
  const [box, setBox] = useState(DEFAULT_BOX);

  useEffect(() => {
    setBox(DEFAULT_BOX);
    if (!src) return undefined;
    let active = true;
    const image = new Image();
    image.onload = () => {
      if (active) setBox(boxFor(image.naturalWidth, image.naturalHeight));
    };
    image.src = src;
    return () => {
      active = false;
    };
  }, [src]);

  return box;
};
